import Siema from './Siema';

export default class mySiema extends Siema {

    //-----------------------
    //-----------------------
    //Pagination
    //-----------------------
    //-----------------------
    paginationInit(options) {
        const _this = this;
        let siemaPagination = document.createElement('div');

        siemaPagination.className = "siema-pagination";

        for (let i = 0; i < this.innerElements.length - (this.perPage - 1); i++) {
            let btn = document.createElement('button');
            btn.textContent = i + 1;
            btn.addEventListener('click', function () {
                return _this.goTo(i);
            });
            siemaPagination.appendChild(btn);
        }

        this.selector.closest(options.carouselEl).appendChild(siemaPagination);
        this.paginationUpdate(options);
    }

    paginationUpdate(options) {
        for (let i = 0; i < this.selector.closest(options.carouselEl).querySelectorAll('.siema-pagination button').length; i++) {
            const currentSlide = (this.config.loop && this.perPage > 1) ? Math.round(this.currentSlide + this.perPage) : Math.round(this.currentSlide);
            const addOrRemove = currentSlide === i ? 'add' : 'remove';
            this.selector.closest(options.carouselEl).querySelectorAll('.siema-pagination button')[i].classList[addOrRemove]('is-active');
        }
    }

    paginationDestroy(options) {
        const siemaContainer = this.selector.closest(options.carouselEl);
        const paginationToRemove = siemaContainer.querySelector('.siema-pagination');
        siemaContainer.removeChild(paginationToRemove);
    }

    //-----------------------
    //-----------------------
    //Arrows
    //-----------------------
    //-----------------------

    arrowsInit(options) {
        const _this = this;
        let siemaArrows = document.createElement('div');

        siemaArrows.className = "siema-arrows";

        this.prevArrow = document.createElement('button');
        this.nextArrow = document.createElement('button');
        this.prevArrow.setAttribute('type', 'button');
        this.nextArrow.setAttribute('type', 'button');
        this.prevArrow.innerHTML = options.arrowsCopy.previous;
        this.nextArrow.innerHTML = options.arrowsCopy.next;
        siemaArrows.appendChild(this.prevArrow);
        siemaArrows.appendChild(this.nextArrow);
        this.selector.closest(options.carouselEl).insertBefore(siemaArrows, null);
        this.arrowsUpdate(options);

        this.prevArrow.addEventListener('click', function () {
            return _this.prev();
        });
        this.nextArrow.addEventListener('click', function () {
            return _this.next();
        });
    }

    arrowsUpdate(options) {
        const siemaArrows = this.selector.closest(options.carouselEl).querySelector('.siema-arrows');
        const prevArrow = siemaArrows.firstChild;
        const nextArrow = siemaArrows.lastChild;

        if (this.currentSlide === 0) {
            prevArrow.classList.remove("is-showing");
            nextArrow.classList.add("is-showing");
        } else if (this.currentSlide === this.innerElements.length - this.perPage) {
            nextArrow.classList.remove("is-showing");
            prevArrow.classList.add("is-showing");
        } else {
            prevArrow.classList.add("is-showing");
            nextArrow.classList.add("is-showing");
        }
    }

    arrowsDestroy(options) {
        const siemaContainer = this.selector.closest(options.carouselEl);
        const arrowsToRemove = siemaContainer.querySelector('.siema-arrows');
        siemaContainer.removeChild(arrowsToRemove);
    }

    //-----------------------
    //-----------------------
    // Print current slides
    //-----------------------
    //-----------------------

    printCurrentSlideInit(options) {
        const _this = this;
        const containerSiema = this.selector.closest(options.carouselEl);
        //console.log(options);
        const siemaSlides = containerSiema.querySelectorAll('.siema-slides-wrapper > div > *');
        const currentSlide = this.config.loop ? Math.round(this.currentSlide + this.perPage) : Math.round(this.currentSlide);
        const lastCurrentSlide = currentSlide + this.perPage - 1;
        //console.log(this);
        //console.log(lastCurrentSlide);

        for (let i = 0; i < siemaSlides.length; i++) {
            siemaSlides[i].tabIndex = 0;
            siemaSlides[i].classList.add('slide');

            siemaSlides[i].addEventListener('focus', function () {
                return _this.goTo(i);
            });

            if (i >= currentSlide && i <= lastCurrentSlide) {
                siemaSlides[i].classList.add('has-active-slide');
                siemaSlides[i].inert = false;
            } else {
                siemaSlides[i].classList.remove('has-active-slide');
                siemaSlides[i].inert = true;
            }
        }
    }
}


export class SiemaControls extends Siema {

    //-----------------------
    //-----------------------
    //Pagination
    //-----------------------
    //-----------------------
    paginationInit(options) {
        const _this = this;
        let siemaPagination = document.createElement('div');

        siemaPagination.className = "siema-pagination";

        for (let i = 0; i < this.innerElements.length - (this.perPage - 1); i++) {
            let btn = document.createElement('button');
            btn.textContent = i + 1;
            btn.addEventListener('click', function () {
                return _this.goTo(i);
            });
            siemaPagination.appendChild(btn);
        }

        const controlsWrapper = this.selector.closest(options.carouselEl).querySelector(options.controlsWrapperEL);
        controlsWrapper.insertBefore(siemaPagination, controlsWrapper.firstChild);
        this.paginationUpdate(options);
    }

    paginationUpdate(options) {
        for (let i = 0; i < this.selector.closest(options.carouselEl).querySelectorAll('.siema-pagination button').length; i++) {
            const currentSlide = (this.config.loop && this.perPage > 1) ? Math.round(this.currentSlide + this.perPage) : Math.round(this.currentSlide);
            const addOrRemove = currentSlide === i ? 'add' : 'remove';
            this.selector.closest(options.carouselEl).querySelectorAll('.siema-pagination button')[i].classList[addOrRemove]('is-active');
        }
    }

    paginationDestroy(options) {
        const siemaContainer = this.selector.closest(options.carouselEl);
        const paginationToRemove = siemaContainer.querySelector('.siema-pagination');
        siemaContainer.removeChild(paginationToRemove);
    }

    //-----------------------
    //-----------------------
    //Arrows
    //-----------------------
    //-----------------------

    arrowsInit(options) {
        const _this = this;
        let siemaArrows = document.createElement('div');

        siemaArrows.className = "siema-arrows";

        this.prevArrow = document.createElement('button');
        this.nextArrow = document.createElement('button');
        this.prevArrow.innerHTML = options.arrowsCopy.previous;
        this.nextArrow.innerHTML = options.arrowsCopy.next;
        siemaArrows.appendChild(this.prevArrow);
        siemaArrows.appendChild(this.nextArrow);
        const controlsWrapper = this.selector.closest(options.carouselEl).querySelector(options.controlsWrapperEL);
        controlsWrapper.insertBefore(siemaArrows, null);

        this.arrowsUpdate(options);

        this.prevArrow.addEventListener('click', function () {
            return _this.prev();
        });
        this.nextArrow.addEventListener('click', function () {
            return _this.next();
        });
    }

    arrowsUpdate(options) {
        const siemaArrows = this.selector.closest(options.carouselEl).querySelector('.siema-arrows');
        const prevArrow = siemaArrows.firstChild;
        const nextArrow = siemaArrows.lastChild;

        if (this.currentSlide === 0) {
            prevArrow.classList.remove("is-showing");
            nextArrow.classList.add("is-showing");
        } else if (this.currentSlide === this.innerElements.length - this.perPage) {
            nextArrow.classList.remove("is-showing");
            prevArrow.classList.add("is-showing");
        } else {
            prevArrow.classList.add("is-showing");
            nextArrow.classList.add("is-showing");
        }
    }

    arrowsDestroy(options) {
        const siemaContainer = this.selector.closest(options.carouselEl);
        const arrowsToRemove = siemaContainer.querySelector('.siema-arrows');
        siemaContainer.removeChild(arrowsToRemove);
    }
    
}